import styles from "./Example.module.css";

export interface ExampleFilters {
    country?: string[];
    region?: string[];
    regionalBureau?: string[];
    evaluationType?: string[];
    qarating?: string[];
    gefEvaluation?: string;
    yearFrom?: string;
    yearTo?: string;
}

interface Props {
    text: string;
    value: string;
    filters?: ExampleFilters;
    onClick: (value: string, filters?: ExampleFilters) => void;
}

export const Example = ({ text, value, filters, onClick }: Props) => {
    return (
        <div className={styles.example} onClick={() => onClick(value, filters)}>
            <p className={styles.exampleText}>{text}</p>
        </div>
    );
};
